// ------------------------------
// プラグインライブラリ読み込み
// ------------------------------
import 'modaal';
import 'slick-carousel';
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
import 'image-map-resizer';

// ------------------------------
// クラスオブジェクト読み込み
// ------------------------------
import Breakpoints from './include/_Breakpoints';
import MatchMedia from './include/_MatchMedia';
import SmoothScroll  from './include/_SmoothScroll';

// ------------------------------
// ブレイクポイント
// ------------------------------
const bp = new Breakpoints({
  all:0,
  pc:768
});


// ------------------------------
// 360px以下viewport固定
// ------------------------------
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 360
        ? 'width=device-width,initial-scale=1'
        : 'width=360';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  Breakpoints.onLazyResize(switchViewport);
  switchViewport();
})();


// ------------------------------
// 呼び込み完了後に【is-loaded】クラス付与
// ------------------------------
window.addEventListener('load',function(){
  const targets = document.querySelectorAll('.js-load');
  if(!(targets)){return false};
  targets.forEach((target) => {
    target.classList.add('is-loaded');
  });
});


// ------------------------------
// SP用 - ハンバーガーナビゲーション開閉
// ------------------------------
class ActiveModule {
  constructor() {
      this.state = false
  }

  off() {
      this.state = false;
  }

  on() {
      this.state = true;
  }
}

$(function () {
  const STATE_NAME = 'is-active';

  function activate($trigger, $target) {
      $trigger.attr('aria-expanded', true);
      $trigger.addClass(STATE_NAME);
      $target.attr('aria-hidden', true);
      $target.addClass(STATE_NAME);
  }

  function deactivate($trigger, $target) {
      $trigger.attr('aria-expanded', false);
      $trigger.removeClass(STATE_NAME);
      $target.attr('aria-hidden', false);
      $target.removeClass(STATE_NAME);
  }

  $('[data-switch-trigger]').each(function () {
      const $trigger = $(this);
      const val = $trigger.attr('data-switch-trigger');
      const $target = $(`[data-switch-target="${val}"]`);
      const $closer = $(`[data-switch-closer="${val}"]`);
      const activeModule = new ActiveModule();

      $trigger.on('click', () => {
          if (activeModule.state === false) {
              activeModule.on();
              activate($trigger, $target);
          } else {
              activeModule.off();
              deactivate($trigger, $target);
          }
      });

      $closer.on('click', () => {
          activeModule.off();
          deactivate($trigger, $target);
      });

      //pcサイズに切り替わったらアクティブクラス除外
      bp.on('change', function () {
          activeModule.off();
          deactivate($trigger, $target);
      });
  });
});


// ------------------------------
// スムーススクロール
// ------------------------------
$(function () {
  $('a[href^="#"]:not([class^="js-"])').each((i, elem) => {
    new SmoothScroll({
      element: elem,
      speed:1000,
    })
  })
});


// ------------------------------
// モーダル
// ------------------------------
$(function () {
  $('[class*="js-modal-"]').each((i, e) => {
    const $e = $(e);

    const modalOptions = {
      animation_speed: 200,
      background:'auto',
      overlay_opacity:'1'
    }

    if($e.data('bg')){
      modalOptions.background = $e.data('bg');
    }
    if($e.data('opacity')){
      modalOptions.overlay_opacity = $e.data('opacity');
    }

    if ($e.hasClass('js-modal-youtube')) {
      if (!$e.attr('href')) {
        $e.attr('href', `https://www.youtube-nocookie.com/embed/${$e.attr('data-youtube')}?autoplay=1&mute=1&rel=0`)
      }
      modalOptions.type = 'video'
    }
    if ($e.hasClass('js-modal-img')) {
      modalOptions.type = 'image';
      if ($e.data('type') == 'chart') {
        modalOptions.custom_class = `modaal-${$e.data('type')}`;
      }
    }
    if ($e.hasClass('js-modal-inline')) {
      modalOptions.type = 'inline';
      if ($e.data('type') == 'cast') {
        modalOptions.custom_class = `modaal-${$e.data('type')}`;
      }
    }
    if ($e.hasClass('js-modal-fullscreen')) {
      modalOptions.type = 'inline';
      modalOptions.fullscreen = true;
    }
    if ($e.hasClass('js-modal-start')) {
      modalOptions.start_open = true
    }
    $e.modaal(modalOptions);
  });
});



// ------------------------------
// 埋め込み動画切り替え
// ------------------------------
$(function () {
  const buttons = $('button[data-embed-id]');
  let regExp = /\/[^/]+$/;
  let STATE_NAME = 'is-active';

  buttons.each(function(){
    $(this).on('click',function(){
        const $target = $(this).parents('.js-embed').find('[data-embed-target]');
        let youtubeID =  `/${$(this).data('embed-id')}`;
        buttons.removeClass(STATE_NAME);
        $target.attr('src',$target.attr('src').replace(regExp,youtubeID));
        $(this).addClass(STATE_NAME);
    });
  });
});

// ------------------------------
// slick
// ------------------------------
//先頭に0をつける
function padNumber(string){
  return string.toString().padStart(2, "0");
}

// slickの初期化
function slickInit(){
  const $slides = $('.js-slides');

  // デフォルトオプション値とオプション格納先
  const defaultOptions = {
    speed:300,
    arrows:false,
  };

  // js-slidesクラスの要素がなければ関数から抜ける
  if ($slides.length < 0){return false };

  // それぞれのslickのtypeでオプションを追加
  $slides.each(function(i,slide){
    let options;
    // typeとドット先セット
    let type = $(slide).data('slides-type');
    // 個別のオプション設定
    switch(type){
      case 'embed':
        options = {
          ...defaultOptions,
          slidesToShow:1,
          asNavFor: $(`[data-slides-type="${$(this).data('sync')}"]`)// メイン画像と同期
        }
        break;
      case 'embed-thumbnail':
        options = {
          ...defaultOptions,
          arrows:true,
          slidesToShow:3,
          swipeToSlide:true,
          focusOnSelect:true,
          minSlides:6, //6枚になるまではスライドさせない
          asNavFor: $(`[data-slides-type="${$(this).data('sync')}"]`),// メイン画像と同期
          responsive: [{
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              minSlides:3,
            }
          },]
        }
        break;
      case 'intro':
        options = {
          ...defaultOptions,
          dots:true,
          appendDots:$(`.js-pager[data-slides-type="${type}"]`),
          arrows:true,
          adaptiveHeight:true,//高さ自動調整
          customPaging: (slider, i) => {
            const text = i === 0 ? '目次': i;
            return text;
          }
        }
        break;
      case 'gallery':
        const controlEL = $('.js-slick-control__inner');
        options = {
          ...defaultOptions,
          arrows:true,
          appendArrows:controlEL,
          autoplay:true,
          slidesToShow:3,
          centerMode:true,
          swipeToSlide:true,
        };

        // スライド番号 / 総数 ※'init'イベントリスナーは初期化前に設定必須
        $(slide).on('init', function (event, slick) {
          let startNumber = Number($(this).filter('[data-slides-start]').data('slidesStart')) - 1;
          if(startNumber > 0){
            slick.slickGoTo(startNumber);
          }
          controlEL.append('<span class="current"></span>　/　<span class="all"></span>');
          controlEL.find('.current').text(slick.currentSlide + 1);
          controlEL.find('.all').text(slick.slideCount);
        })
        .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          controlEL.find('.current').text(nextSlide + 1);
        });

        break;
      case 'chart':
        options = {
          ...defaultOptions,
          arrows:true,
        }

        // chart - スワイプ直後にボタンにアクティブクラスを付与する
        $(slide).on('afterChange', function (event, slick, currentSlide) {
          const $button = $('.js-changeButton').children('button');
          $button.removeClass('is-active');
          $button.eq(currentSlide).addClass('is-active');
        });

        break;
        case 'story':

    // 最初に表示するスライドの動画を読み込む
    $(slide).on('init', function (event, slick) {
      const currentSlide = slick.currentSlide;
      const $iframe = $(slick.$slides[currentSlide]).find('iframe[data-src]');

      $iframe.attr('src', $iframe.attr('data-src'));
    });

    // 移動前に、現在再生中の動画を停止・解放する
    $(slide).on('beforeChange', function (event, slick, currentSlide) {
      const $iframe = $(slick.$slides[currentSlide]).find('iframe[data-src]');

      $iframe.removeAttr('src');
    });

    // 移動後に、新しいスライドの動画を読み込む
    $(slide).on('afterChange', function (event, slick, currentSlide) {
      const $iframe = $(slick.$slides[currentSlide]).find('iframe[data-src]');

      $iframe.attr('src', $iframe.attr('data-src'));
    });

    options = {
      ...defaultOptions,
      infinite: false,
      dots: true,
      appendDots: $(`.js-pager[data-slides-type="${type}"]`),
      initialSlide: $('.story-slides__item').length - 1,
      customPaging: (slider, i) => {
        const text = i === 0 ? 'あらすじ' : i;
        return text;
      }
    }
    break;

        case 'sell':
          options = {
            ...defaultOptions,
            dots:true,
            appendDots:$(`.js-pager[data-slides-type="${type}"]`),
            initialSlide:0,
            customPaging: (slider, i) => {
              const text = 'SET ' + (i + 1);
              return text;
            }
          }
          break;
        default:
          options = defaultOptions;
          break;
      }
      // 各 case ブロックの最後で slick メソッドを実行
      $(slide).slick(options);
    });
    //メディアクエリでslickの設定切り替え
  new MatchMedia((isPC) => {
    if(isPC){
      $slides.filter('[data-slides-type="gallery"]').slick('slickSetOption', {slidesToShow:3 }, true);
    }else{
      $slides.filter('[data-slides-type="embed-thumbnail"]').slick('slickSetOption', {}, true);
      $slides.filter('[data-slides-type="gallery"]').slick('slickSetOption', {slidesToShow:1 }, true);
    }
  });
  };

  function changeButton(){
    const $changeTargets = $('.js-changeButton');
    const $buttons = $changeTargets.find('button');
    if($changeTargets.length < 0){ return false };

    $buttons.each(function(i,button){
      let type = $(button).parents('.js-changeButton').data('slides-type');
      const targetSlide = $(`.js-slides[data-slides-type="${type}"]`);

      switch (type){
        case 'story':
          // filter番号
          let start = $(button).data('change').split('-')[0];
          let end = $(button).data('change').split('-')[1];

          // data属性からフィルタリング
          $(button).on('click',function(i){
            $buttons.removeClass('is-active');
            $(this).addClass('is-active');

            // filterをリセット
            targetSlide.slick('slickUnfilter');

            // filterセット
            targetSlide.slick('slickFilter',function(slide){
              return slide === 0 || slide >= start && slide <= end;
            });

            // ページネーション番号更新 $('.foo').slick('slickSetOption', {option:value,...}, refresh);
            targetSlide.slick('slickSetOption', {
              customPaging: (slider, i) => {
                let number = start - 1;
                const text = i === 0 ? 'あらすじ' : padNumber(number + i);
                return text;
              },
            }, true);

            // slickの１番目に移動
            targetSlide.slick('slickGoTo', 1);
          });
          break;
        default:
          let number = $(button).data('change');
          $(button).on('click',function(){
            targetSlide.slick('slickGoTo', number);
          })
          break;
      }
  });

  // 最初のボタンを１回クリックさせる
  $changeTargets.filter('[data-slides-type="story"]').children('button').eq(0).click();
}

$(function(){
  slickInit();
  changeButton();
});

// ------------------------------
// アコーディオン
// ------------------------------
$(function(){
  const $buttons = $('.js-accordion');

  $buttons.each(function(i,button){
    $(button).on('click',function(event){
      const id = $(button).data('target');
      $(this).toggleClass('is-active');
      $(`#${id}`).slideToggle();
    });
  });
});

// ------------------------------
// TOPに戻る
// ------------------------------
$(function(){
  function backTop(){
    const $hero = $('.l-hero');
    const $button = $('.js-button-top');
    let h = $hero.height();
    let scrollTop = $(window).scrollTop();

    if(h < scrollTop ){
      $button.addClass('is-scrolled');
    }else{
      $button.removeClass('is-scrolled');
    }
  };

  backTop();
  Breakpoints.onLazyResize(backTop);
  window.addEventListener('scroll',backTop);
});


// ------------------------------
// アニメーション
// ------------------------------
document.addEventListener('DOMContentLoaded',function(){

  // 読み込み後表示
  document.querySelectorAll('.js-load').forEach((EL) => {
    EL.classList.add('is-view');
  });

  // スクロールトリガー　is-viewクラス付与
  document.querySelectorAll('.js-scroll').forEach(section => {
    let start = section.dataset.start;

    gsap.fromTo(
      section,
      {
        alpha:0,
        filter:'blur(20px)',
        y:'20%'
      },
      {
        alpha: 1,
        filter:'blur(0px)',
        y:'0',
        scrollTrigger: {
          trigger: section,
          start: start? start:"top 80%",
          end: "bottom 20%",
          toggleClass: "is-view", // このクラスがトグルされます
        },
      }
    );
  });

  // derayずらしたアニメーション
  const bubbles = document.querySelectorAll(".js-bubbles");
  document.querySelectorAll(".js-bubbles").forEach((bubble,i) => {
    const childElements = Array.from(bubble.children);

    gsap.fromTo(childElements,{y:100, alpha:0}, {
      y: 0,
      alpha: 1,
      stagger: { each:0.15 },
      scrollTrigger: {
        trigger: childElements, // トリガー要素
        start: "top 80%", // スクロールトリガーの開始位置
        end: "bottom 20%", // スクロールトリガーの終了位置
      },
    });
  });
});


// モーダルコメント

$('.js-modaal-comment').modaal({
  type: 'inline',
  overlay_close: true,
  custom_class: 'modaal-comment-custom',
  after_open: function () {
    const $slider = $('.js-comment-slides');
    if (!$slider.hasClass('slick-initialized')) {
      $slider
      .on('init', function () {
        // 初期化後に表示
        $(this).css('display', 'block');
      })

      .slick({
        arrows: false,
        dots: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: false,
        infinite: false,
        variableWidth: false,
        mobileFirst: true
      });
// 念のため再計算
      setTimeout(() => {
        $slider.slick('setPosition');
      }, 100);
    } else {
      // 2回目以降：再表示のみ
      $slider.css('display', 'block');
    }
  },
  after_close: function () {
    const $slider = $('.js-comment-slides');

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    // モーダル閉じたら再度非表示に
    $slider.css('display', 'none');
  }
});

// TOP画像ふわっと切り替え
document.addEventListener("DOMContentLoaded", () => {

  const hero = document.getElementById("hero");

  const kvs = document.querySelectorAll(".hero__kv");
  const catches = document.querySelectorAll(".hero__catch");

  let current = 2;

  function switchHero() {

    // KVは共通
    kvs[current].classList.remove("active");

    // PCのみcatch/
    if (window.innerWidth >= 768) {
      catches[current].classList.remove("active");
    }

    current = (current + 1) % kvs.length;

    kvs[current].classList.add("active");

    if (window.innerWidth >= 768) {
      catches[current].classList.add("active");

      hero.classList.remove(
        "theme-1",
        "theme-2",
        "theme-3"
      );
      hero.classList.add(`theme-${current + 1}`);
    }
  }

  setInterval(switchHero, 6000);

});


// 画像縮小
$('map').imageMapResize();
